export const LOAD_ACCOUNTANCY_SOFTWARE = 'LOAD_ACCOUNTANCY_SOFTWARE'
export const LOAD_ACCOUNTANCY_SOFTWARE_SUCCESS = 'LOAD_ACCOUNTANCY_SOFTWARE_SUCCESS'
export const LOAD_ACCOUNTANCY_SOFTWARE_FAILED = 'LOAD_ACCOUNTANCY_SOFTWARE_FAILED'

export const CREATE_ACCOUNTANCY_SOFTWARE = 'CREATE_ACCOUNTANCY_SOFTWARE'
export const CREATE_ACCOUNTANCY_SOFTWARE_SUCCESS = 'CREATE_ACCOUNTANCY_SOFTWARE_SUCCESS'
export const CREATE_ACCOUNTANCY_SOFTWARE_FAILED = 'CREATE_ACCOUNTANCY_SOFTWARE_FAILED'

export const UPDATE_ACCOUNTANCY_SOFTWARE = 'UPDATE_ACCOUNTANCY_SOFTWARE'
export const UPDATE_ACCOUNTANCY_SOFTWARE_SUCCESS = 'UPDATE_ACCOUNTANCY_SOFTWARE_SUCCESS'
export const UPDATE_ACCOUNTANCY_SOFTWARE_FAILED = 'UPDATE_ACCOUNTANCY_SOFTWARE_FAILED'
